import { Locale } from '@synergy/models';
import { getLocalizedString } from '@synergy/utils';

import { NewsPost } from '../news-post';
import { NewsPostDto } from '../dto/news-post-dto';

export const mapNewsPost = (locales: Locale[], newsPost: NewsPostDto): NewsPost => ({
    id: newsPost.id,
    text: getLocalizedString(locales, newsPost.text),
    thumbnailUrl: newsPost.image?.['489x274'],
    imageUrl: newsPost.image?.['700x394'],
    title: getLocalizedString(locales, newsPost.title),
    publishAt: (newsPost.publishAt && new Date(newsPost.publishAt)) ?? new Date(),
});
